import React, { useEffect, useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header/Header";
import { useAppDispatch, useAppSelector } from "../redux/app/hooks";
import { useFindBlogDetailByIdMutation } from "../redux/services/blogsApi";
import { getBlogsData, setblogs } from "../redux/slices/blogsSlice";
import Loading from "../pages/commons/Loading";
import Footer from "../components/Footer/Footer";

interface Blog {
  id: number;
  title: string;
  description: string;
  imageUrl: string;
}

function FindLatestNews() {
  const dispatch: any = useAppDispatch();
  const navigate = useNavigate();
  const location: any = useLocation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const userToken: string = currentUser?.jwtToken;

  const [findBlogDetailById, findBlogDetailByIdResponse] =
    useFindBlogDetailByIdMutation();
  const [blog, setBlog] = useState<Blog | null>(null);
  const blogData: Blog | null = useAppSelector(getBlogsData);

  useEffect(() => {
    if (location.state?.id) {
      findBlogDetailById({
        id: location.state.id,
      });
    }
  }, [location.state?.id, findBlogDetailById]);

  useEffect(() => {
    if (findBlogDetailByIdResponse.isSuccess) {
      dispatch(setblogs(findBlogDetailByIdResponse.data));
    }
  }, [findBlogDetailByIdResponse.isSuccess, dispatch]);

  useEffect(() => {
    if (blogData) {
      setBlog(blogData);
    }
  }, [blogData]);

  return (
    <div className="flex flex-col h-screen justify-between">
      <div>
        <div className="h-[75px] z-10 fixed mx-10 ">
          <Header position={"fixed"} isLoggedIn={userToken ? true : false} />
        </div>
        {findBlogDetailByIdResponse.isLoading ? <Loading /> : null}
        <div className="p-[20px] lg:px-[24px] my-[40px] md:mx-[13px] lg:mx-[60px] rounded-[16px] h-auto mt-[100px]">
          <IoMdArrowRoundBack
            className="md:text-[40px] text-[30px] cursor-pointer"
            onClick={() => {
              navigate("/view-all-detail");
            }}
          />
          <div className="w-full p-1 lg:h-[410px]">
            {blog ? (
              <img
                src={blog.imageUrl}
                alt={blog.title || "Blog Image"}
                className="block object-cover object-center w-full h-full rounded-lg"
              />
            ) : (
              <div className="w-full h-full flex justify-center items-center">
                <p>No image available</p>
              </div>
            )}
          </div>

          <p className="mt-6 font-bold lg:text-2xl text-xl text-[#3B3A40] mx-[10px]">
            {blog?.title || "No Title"}
          </p>
          <div
            className="mt-2 lg:text-lg text-base mx-[10px]"
            dangerouslySetInnerHTML={{
              __html: blog?.description || "<p>No Description Available</p>",
            }}
          />
        </div>
      </div>
      <div className="items-end">
        <Footer />
      </div>
    </div>
  );
}

export default FindLatestNews;